import { lazy } from 'react';
/** Открывает список заказов */
export const OrdersPageAsync = lazy(() => import('./Orders/OrdersPage'));